import { useEffect } from 'react';

interface PageMetaOptions {
  title: string;
  description?: string;
}

/**
 * ページのタイトルと description メタタグを動的に設定するフック
 * @param options - ページメタ情報
 * 
 * 使用例:
 *   usePageMeta({
 *     title: 'パスワードリセット - 企画苔',
 *     description: 'アカウントのパスワードをリセットします。メールに送信された確認コードを入力してください。'
 *   });
 */
export function usePageMeta(options: PageMetaOptions): void {
  useEffect(() => {
    // ページタイトルを設定
    document.title = options.title;

    // description メタタグを設定または更新
    let metaDescription = document.querySelector('meta[name="description"]');
    if (!metaDescription) {
      metaDescription = document.createElement('meta');
      metaDescription.setAttribute('name', 'description');
      document.head.appendChild(metaDescription);
    }
    if (options.description) {
      metaDescription.setAttribute('content', options.description);
    }
  }, [options.title, options.description]);
}
